export default {
  'pages.common.save': '儲存',
  'pages.common.cancel': '取消',
  'pages.common.confirm': '確定',
  'pages.common.ok': '確定',
  'pages.common.delete': '刪除',
  'pages.common.edit': '編輯',
  'pages.common.add': '新增',
  'pages.common.append': '添加',
  'pages.common.search': '查詢',
  'pages.common.reset': '重置',
  'pages.common.submit': '提交',
  'pages.common.back': '返回',
  'pages.common.close': '關閉',
  'pages.common.export': '匯出',
  'pages.common.import': '匯入',
  'pages.common.refresh': '重新整理',
  'pages.common.detail': '詳情',
  'pages.common.copy': '複製',
  'pages.common.operation': '操作',
  'pages.common.view': '檢視',
  'pages.common.download': '下載',
  'pages.common.upload': '上傳',
  'pages.common.yes': '是',
  'pages.common.no': '否',
  'pages.common.loading': '載入中…',
  'pages.common.more': '更多',
  'pages.common.all': '全部',
  'pages.common.createSuccess': '新增成功',
  'pages.common.saveSuccess': '儲存成功',
  'pages.common.deleteSuccess': '刪除成功',
  'pages.common.deleteFailed': '刪除失敗',
  'pages.common.saveFailed': '儲存失敗',
  'pages.common.loadFailed': '載入失敗',
  'pages.common.requiredField': '此項為必填',
  'pages.common.selectedCount': '已選擇 {count} 項',
  'pages.common.clearSelection': '取消選擇',
  'pages.common.totalRecords': '共 {total} 筆記錄',
  'pages.common.batchDeleteCount': '批量刪除 ({count})',
  'pages.common.statusSuccess': '成功',
  'pages.common.statusFailed': '失敗',
  'pages.common.timeRangeStart': '開始時間',
  'pages.common.timeRangeEnd': '結束時間',
  'pages.common.unnamed': '未命名',
  'pages.common.operationFailedRetry': '操作失敗，請重試',
  'pages.common.batchDeleteSuccess': '批量刪除成功',
  'pages.common.batchDeleteFailed': '批量刪除失敗，請重試',
  'pages.common.nItemsFailed': '{count} 項失敗',
  'pages.common.enable': '啟用',
  'pages.common.disable': '禁用',
  'pages.common.statusNormal': '正常',
  'pages.common.statusDisabled': '禁用',
  'pages.common.selectOrganization': '請選擇機構',
  'pages.common.batchDeleteTitle': '確認批量刪除',
  'pages.common.downloadingTemplate': '正在下載範本…',
  'pages.common.templateDownloadSuccess': '範本下載成功',
  'pages.common.templateDownloadFailed': '範本下載失敗，請稍後重試',
};
